import BeeswaxCatchupBehavior from '@/Enums/Beeswax/BeeswaxCatchupBehavior.enum';
import BeeswaxPacing from '@/Enums/Beeswax/BeeswaxPacing.enum';
import BeeswaxPacingBehavior from '@/Enums/Beeswax/BeeswaxPacingBehavior.enum';
import LineItemFormTab from '@/Enums/CampaignManagement/LineItemFormTab.enum';
import Channel from '@/Enums/Channel.enum';
import { ChannelId } from '@/Enums/ChannelId.enum';
import type { ILineItemForm } from '@/Interfaces/CampaignManagement/LineItem.interface';
import AudienceTargetingService from '@/Services/AudienceTargeting.service';
import { LINE_ITEM_DEFAULT_GEO, NEW_ITEM_ID } from '@/constants/campaignManagement';
import type { FC } from 'react';
import LineItemFormAudienceSection from './../AudienceSection';
import LineItemFormBasicSection from './../BasicSection';
import LineItemFormCreativesSection from './../Creatives';
import LineItemFormDaypartSection from './../Daypart';
import { ALL_WEEK } from './../Daypart/constants';
import LineItemFormDealGroupsSection from './../DealGroups';
import LineItemFormGeoSection from './../GeoSection';
import LineItemFormSummarySection from './../Summary';

export const EXPAND_ICON_CLASSNAME = 'cursor-pointer transition duration-500 w-6 h-6';

export const LINE_ITEM_TABS_COMPONENTS: Record<LineItemFormTab, FC<any>> = {
  [LineItemFormTab.Basic]: LineItemFormBasicSection,
  [LineItemFormTab.Geo]: LineItemFormGeoSection,
  [LineItemFormTab.Audience]: LineItemFormAudienceSection,
  [LineItemFormTab.DealGroups]: LineItemFormDealGroupsSection,
  [LineItemFormTab.Daypart]: LineItemFormDaypartSection,
  [LineItemFormTab.Creatives]: LineItemFormCreativesSection,
  [LineItemFormTab.Summary]: LineItemFormSummarySection,
};

export const defaultFormData: ILineItemForm = {
  id: NEW_ITEM_ID,
  isRibeyeEntry: true,
  name: '',
  impressionsBooked: null,
  soldCpm: null,
  bidCpm: null,
  startDate: null,
  endDate: null,
  channel: { label: Channel.CTV, value: ChannelId.CTV },
  devices: [],
  product: null,
  frequencyCaps: {
    hourly: null,
    weekly: null,
    daily: null,
    monthly: null,
  },
  pacingBehavior: BeeswaxPacingBehavior.Even,
  catchupBehavior: BeeswaxCatchupBehavior.Even,
  dailyBudget: null,
  geo: LINE_ITEM_DEFAULT_GEO,
  geoFence: null,
  audiences: AudienceTargetingService.defaultLineItemAudienceTargeting,
  daypart: ALL_WEEK,
  duplicates: [],
  creatives: [],
  firstPartySegments: [],
  publisherIds: [],
  dealGroups: [],
  packageId: null,
  altId: '',
  pacing: BeeswaxPacing.Lifetime,
  hasCustomDomainLists: false,
  customAllowDomains: [],
  customBlockDomains: [],
};
